import { CustomComponent } from './CustomComponent.model';
import { CustomTemplateDTO } from '../dto/template/customTemplate.dto';

export class CustomTemplate {
    id?: number;
    uuid: string;
    name: string;
    isstatic: boolean;
    customComponents: CustomComponent[];
    
    constructor(name: string, isstatic: boolean, customComponents: CustomComponent[], id?: number, uuid?: string) {
      this.id = id;
      this.uuid = uuid || this.generateUUID();
      this.name = name;
      this.isstatic = isstatic;
      this.customComponents = customComponents;
    }
  
    private generateUUID(): string {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    /*public fromGridsterItems(gridsterItems: any): void {
        this.customComponents = gridsterItems;
    }*/

    public static convertToDTO(template: CustomTemplate): CustomTemplateDTO {
      return {
        id: template.id,
          uuid: template.uuid,
          name: template.name,
          isstatic: template.isstatic,
          customComponents: template.customComponents.map(comp => CustomComponent.convertToDTO(comp)),
        };
    }

    public static fromDTO(dto: CustomTemplateDTO): CustomTemplate {
        return new CustomTemplate(
          dto.name,
          dto.isstatic,
          dto.customComponents ? dto.customComponents.map(compDTO => CustomComponent.fromDTO(compDTO)) : [],
          dto.id,
          dto.uuid
        );
    }

    /*public getStaticTemplate(): CustomComponent[] {
        return this.customComponents.filter(comp => comp.isstatic);
    }

    public getDynamicTemplate(): CustomComponent[] {
        return this.customComponents.filter(comp => !comp.isstatic);
    }*/
}